import { alpha, SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { FC, ReactNode } from 'react';
import { PiX } from 'react-icons/pi';

export interface DialogTitleProps {
  id?: string;
  children: ReactNode;
  onClose?: () => void;
  sx?: SxProps;
  /** Icon shown to the left of the title in a rounded square */
  icon?: ReactNode;
  /** Subtitle shown below the title */
  subtitle?: ReactNode;
}

export const DialogTitle: FC<DialogTitleProps> = props => {
  const { id: _id, children, onClose, sx: _sx, icon, subtitle, ...other } = props;
  return (
    <MuiDialogTitle
      sx={{
        p: 1.8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
      }}
      {...other}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          flex: 1,
          minWidth: 0,
        }}
      >
        {icon && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 36,
              height: 36,
              mr: 1.5,
              borderRadius: 1.5,
              bgcolor: theme => alpha(theme.palette.common.white, 0.15),
              flexShrink: 0,
              fontSize: 20,
            }}
          >
            {icon}
          </Box>
        )}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            lineHeight: 1.1,
            flex: 1,
            minWidth: 0,
          }}
        >
          {children}

          {subtitle && (
            <Typography variant="caption" sx={{ opacity: 0.75, display: 'block' }} noWrap>
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>

      {onClose && (
        <IconButton
          color="inherit"
          onClick={onClose}
          sx={{
            backgroundColor: theme => alpha(theme.palette.common.white, 0.15),
            borderRadius: 2,
          }}
        >
          <PiX size={25} />
        </IconButton>
      )}
    </MuiDialogTitle>
  );
};
